import { useEffect, useRef, useState } from 'react';

/**
 * Smooths over multiple loading state changes.
 *
 * Useful when multiple states are loaded one at a time with a tiny delay in between.
 */
export function useSmoothLoading(loading: boolean, smoothOverMs = 20): boolean {
  const [smoothedLoading, setSmoothedLoading] = useState(loading);
  const timeoutId = useRef<number>();

  useEffect(
    function debounceLoadingChanges() {
      window.clearTimeout(timeoutId.current);
      timeoutId.current = window.setTimeout(setSmoothedLoading, smoothOverMs, loading);
    },
    [loading]
  );

  return smoothedLoading;
}
